import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '../Link/Link.js';
import { Text } from '../Text/Text.js';
import { FoundersFeedbackIllustration } from './FoundersFeedbackIllustration.js';
import { FOUNDERS_FEEDBACK_STRINGS, FOUNDERS_EMAIL } from './strings.js';

function FoundersFeedbackCard({
  name
}) {
  return jsxs("div", {
    className: "border-gray overflow-hidden rounded border border-solid bg-white",
    children: [jsx("div", {
      className: "bg-light-gray",
      children: jsx(FoundersFeedbackIllustration, {})
    }), jsxs("div", {
      className: "border-gray p-2sm border-x-0 border-b-0 border-t border-solid",
      children: [jsxs(Text, {
        variant: "p1",
        fontWeight: "semibold",
        className: "text-navy mb-2sm block text-center",
        children: [FOUNDERS_FEEDBACK_STRINGS.promptLead, jsx("br", {}), FOUNDERS_FEEDBACK_STRINGS.promptQuestion]
      }), jsx(Link, {
        variant: "solid",
        buttonType: "primary",
        size: "fluid",
        href: FOUNDERS_EMAIL,
        name: name,
        className: "h-[48px]",
        children: jsx(Text, {
          variant: "p1",
          fontWeight: "semibold",
          children: FOUNDERS_FEEDBACK_STRINGS.cta
        })
      })]
    })]
  });
}

export { FoundersFeedbackCard };
